import { MKPoint } from '@bluebeam/markupkit-web';
import { Entity, World } from '$legacyecstatic';
import { Components } from 'editor/components';
import MarkupKit from 'editor/components/MarkupKit';
import Markup from '../components/Markup';
import Overlay from '../components/Overlay';

// Should this be moved up to app utils hit detection?
export function pointInCircle(
  circleX: number,
  circleY: number,
  x: number,
  y: number,
  radius: number
): boolean {
  const d = Math.sqrt((circleX - x) ** 2 + (circleY - y) ** 2);
  return d <= radius;
}

export function getHitMarkups(
  world: World<Components>,
  point: MKPoint
): Entity<Components>[] {
  return world.locateAll([Markup, Overlay]).filter((entity) => {
    const mc = entity.get<Markup>(Markup);

    if (!mc.mkMarkup || mc.hidden) {
      return false;
    }

    const isHit = mc.mkMarkup.hit(point);

    return isHit;
  });
}

export function hitMarkupFilter(
  x: number,
  y: number,
  entity: Entity<Components>
): boolean {
  const markupComp = entity.get(Markup);
  const markupkitComp = entity.get(MarkupKit);

  const point = new markupkitComp.MKPoint(x, y);

  if (!markupComp.mkMarkup || markupComp.hidden) {
    return false;
  }

  const isHit = markupComp.mkMarkup.hit(point);

  return isHit;
}

// TODO: Need to work out some better shared ways to search for things on the world.
export function getHitMarkups2(
  world: World<Components>,
  x: number,
  y: number
): Entity<Components>[] {
  return world
    .locateAll([Markup, MarkupKit])
    .filter((entity) => hitMarkupFilter(x, y, entity));
}
